"use client";

import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

import { TabsIndicator, TabsIndicators } from "@/components/ui/tabs";
import { ModuleTabbedHero } from "@/lib/types";
import { cn } from "@/lib/ui/cn";

type IndicatorsProps = {
  headerId: string;
  tabs: ModuleTabbedHero["tabs"];
};

export const Indicators = ({ headerId, tabs }: IndicatorsProps) => {
  const [headerElement, setHeaderElement] = useState<HTMLElement | null>(null);
  useEffect(() => {
    const header = document.getElementById(headerId);
    if (header) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setHeaderElement(header);
    }
  }, [headerId]);

  const renderIndicators = (className?: string) => {
    return (
      <TabsIndicators className={cn("animate-in fade-in", className)}>
        {tabs.map((tab) => (
          <TabsIndicator key={tab._key} value={tab._key} />
        ))}
      </TabsIndicators>
    );
  };

  return (
    <>
      {renderIndicators("tablet:hidden flex justify-start mt-gap-element-xl")}
      {headerElement &&
        createPortal(renderIndicators("hidden tablet:flex justify-end "), headerElement)}
    </>
  );
};
